<template>
  <div>
    <div
      class="container-sidebar "
    >
      <h4 class="title">
        Navegación
      </h4>
      <div class="btn-nav">
        <p uk-margin>
          <button
            class="uk-button uk-button-default"
            @click="resetCosts"
          >
            Recomenzar
          </button>
        </p>
      </div>

      <ul class="uk-list uk-margin-remove">
        <li
          v-for="(page, index) in nestedPages"
          v-show="page.isVisible"
          :key="index"
          class="text"
        >
          <span :class="getBackground(page, isParentSuccess(page))">
            <span
              class="uk-badge"
            >
              <span v-if="!isParentSuccess(page)">{{ myCont + index }}</span>
              <font-awesome-icon
                v-if="isParentSuccess(page)"
                icon="check"
              />
            </span>
          </span>

          <span :class="getBackground(page)">
            <span
              class="conditionRes"
            >
              {{ page.title }}
            </span>
          </span>

          <ul class="uk-list sublist">
            <li
              v-for="(sub, subIndex) in page.children"
              v-show="sub.isVisible"
              :key="subIndex"
            >
              <span
                :class="{current:sub.isCurrent, succed: isParentSuccess(sub), normal:getBackgroundSubList(sub)}"
              >
                <span
                  class="uk-badge my-badge"
                >
                  <span v-if="!isParentSuccess(sub)">{{ index + 1 }}.{{ subIndex + 1 }}</span>
                  <font-awesome-icon
                    v-if="isParentSuccess(sub)"
                    class="my-badge"
                    icon="check"
                  />
                </span>

                <span class="sub-list-items">
                  {{ sub.title }}
                </span>
              </span>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="container-responsive">
      <h4 class="title">
        Navegación
      </h4>

      <nav class="uk-flex uk-flex-between uk-flex-wrap nav-responsive">
        <div class="currentPage">
          {{ currentPage?.title }}
        </div>

        <div
          v-if="beforePage?.title == null"
          class="beforeNull"
        >
          {{ beforePage?.title }}
        </div>

        <div
          v-else
          class="beforePage"
        >
          {{ beforePage?.title }}
        </div>

        <div
          v-if="beforePage?.title == null"
          class="nextNull"
        >
          {{ nextPage?.title }}
        </div>

        <div
          v-else
          class="nextPage"
        >
          {{ nextPage?.title }}
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      backgroundIsActive: true,
      myCont: 1
    }
  },
  computed: {
    ...mapGetters([
      'nestedPages',
      'visiblePages'
    ]),
    beforePage: function () {
      const tempVisiblePages = [...this.visiblePages].reverse()
      const index = tempVisiblePages.findIndex(x => x.isCurrent) + 1
      if (index >= 0) return tempVisiblePages[index]

      return null
    },
    currentPage: function () {
      const tempVisiblePages = [...this.visiblePages].reverse()
      return tempVisiblePages.find(x => x.isCurrent)
    },
    nextPage: function () {
      const tempVisiblePages = [...this.visiblePages].reverse()
      const index = tempVisiblePages.findIndex(x => x.isCurrent) - 1
      if (index < tempVisiblePages.length) return tempVisiblePages[index]

      return null
    }
  },

  methods: {

    isParentSuccess (page) {
      return !page.children ? page.isSucced : page.children.every(e => e.isSucced)
    },
    getBackground (page, isSucced) {
      if (isSucced || page.isSucced) return 'succed'
      if (page.isCurrent) return 'current'
      return 'normal'
    },
    getBackgroundSubList (sub) {
      if (sub.isCurrent) return 'current'
      if (sub.isSucced) return 'succed'
      return 'false'
    },
    resetCosts () {
      this.$store.dispatch('resetCosts')
    },

    pushPage (name) {
      this.$router.push({ name })
      this.$windowPlugin.scrollToTop()
    }

  }
}
</script>

<style scoped>
.uk-badge{
  background: inherit !important;
  color: #333;
  float: left;
}
.normal .uk-badge {
  margin-right: 5px ;
}
.succed .uk-badge {
  background-color: green !important;
  color: white;
}
.current span{
  font-weight: 600;
}
.normal span{
  color: rgb(138, 137, 137)  !important;
}

.sublist .succed span,
.sublist .current span{
  color: #333 !important;
  background: inherit !important;
}
.sublist{
  margin-left: 25px;
}
.conditionRes{
  display: block;
  padding: 0px 29px;
  color: rgb(49, 49, 49);

}
.sub-list-items{
  color: rgb(49, 49, 49) !important;

}
.container-sidebar{
  padding: 5px 10px;
  max-height: 530px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 0px;
}
::-webkit-scrollbar-thumb {
  background: #005d85;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #002c3f;
}

::-webkit-scrollbar-thumb:active{
  background: #002c3f;

}
.uk-list li{
  margin: 5px 0px 15px;
}
.title{
  margin: 0px;
  font-weight:600;
}
.sublist{
  font-size: 12px ;
  width: 90%;
}
.text{
  text-align: start;
}
.btn-nav{
  margin-top: 10px;
}
.container-responsive{
    display: none;
}

.beforeNull{
  display: none;
}

.beforePage{
  color: rgba(0, 161, 75, 0.637);
  margin-top: 15px;
  display: block;
  max-width: 130px;
  width: 50%;

}
.currentPage{
  font-weight: 600;
  color: #333;
  display: inline-block;
  width: 100%;
  text-align: center;
  }
.nextPage{
  color: rgb(187, 186, 186);
  margin-top: 15px;
  max-width: 130px;
  text-align: center;
  width: 50%;
  display: block;

}

.nextNull{
  /* display: none; */
  display: block;
  text-align: end;
  width: 100%;

}
@media screen and (max-width: 879px){
  .title{
    font-size: 16px;
  }
  *{
    font-size: 11px;
  }
}
@media screen and (max-width: 689px){
  .title{
    font-size: 14px;
  }
  *{
    font-size: 10px;
  }
}

@media screen and (max-width: 600px){
  .container-sidebar{
    display: none;
  }

  .title{
    display: none;
  }

  .container-responsive{
    display: flex;
    justify-content: space-around;
  }

  .nav-responsive{
  font-size: 10px;
  width: 95%;
  height: auto;
  padding: 0px 10px;
  margin: 5px 0px 5px 5px;
}
}

</style>
